import {
  ArrowRightIcon,
  ArrowTopRightOnSquareIcon,
} from '@heroicons/react/20/solid';
import { useLocation } from '@reach/router';
import clsx from 'clsx';
import { Link } from 'gatsby';
import React from 'react';

interface Props {
  data: any;
  className?: string;
  onLinkClick?: () => void;
}

const Aside: React.FC<Props> = ({ data, className, onLinkClick }) => {
  const location = useLocation();

  return (
    <div className={className}>
      <nav className='text-xs font-bold'>
        <ul role='list' className='pb-12 xl:py-16'>
          {data.node.sections.map((section: any) => (
            <li key={section.title}>
              <h2 className='px-6 py-4 text-lsGray-400 xl:pb-2'>
                {section.title}
              </h2>
              <ul role='list'>
                {section.links.map((link: any) => (
                  <li key={link.href} className='relative'>
                    <div
                      className={clsx(
                        'text-white/20',
                        link.href === location.pathname.replace(/\/$/, '')
                          ? 'bg-white/5'
                          : 'hover:bg-white/5',
                      )}
                    >
                      {link.isOpenNewTab ? (
                        <a
                          href={link.href}
                          target='_blank'
                          rel='noopener noreferrer'
                          onClick={onLinkClick}
                          className={clsx(
                            'flex w-full items-center justify-between px-6 py-4',
                            link.href === location.pathname.replace(/\/$/, '')
                              ? '[&>div]:text-transparent'
                              : '[&>div]:text-white/20 [&>div]:hover:text-white/50',
                          )}
                        >
                          <p className='mr-3 text-white'>{link.title}</p>
                          <div>
                            <ArrowTopRightOnSquareIcon
                              className='h-6 w-6'
                              aria-hidden='true'
                            />
                          </div>
                        </a>
                      ) : (
                        <Link
                          to={link.href}
                          onClick={onLinkClick}
                          className={clsx(
                            'flex w-full items-center justify-between px-6 py-4',
                            link.href === location.pathname.replace(/\/$/, '')
                              ? '[&>div]:text-transparent'
                              : '[&>div]:text-white/20 [&>div]:hover:text-white/50',
                          )}
                        >
                          <p className='mr-3 text-white'>{link.title}</p>
                          <div>
                            <ArrowRightIcon
                              className='h-6 w-6'
                              aria-hidden='true'
                            />
                          </div>
                        </Link>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

Aside.displayName = 'Aside';

export default Aside;
